import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();
export const behaviourCaptureState = atom<boolean>({
  key: 'behaviourCaptureState',
  default: false,
  effects_UNSTABLE: [persistAtom],
});
